(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../../styles/colors', '../../styles/fonts/fonts'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../../styles/colors'), require('../../styles/fonts/fonts'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.colors, global.fonts);
    global.ButtonsCss = mod.exports;
  }
})(this, function (exports, _colors, _fonts) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.buttonFlatStyles = exports.buttonSecondaryStyles = exports.buttonPrimaryStyles = exports.buttonSmallStyles = exports.buttonLargeStyles = exports.buttonCoreStyles = undefined;

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var jungle = _colors2.default.jungle,
      slate = _colors2.default.slate,
      white = _colors2.default.white,
      stone = _colors2.default.stone,
      silver = _colors2.default.silver,
      platinum = _colors2.default.platinum;
  var buttonCoreStyles = exports.buttonCoreStyles = '\n  text-transform: capitalize !important;\n  font-style: normal;\n  font-stretch: normal !important;\n  font-family: ' + _fonts.ProximaNova + ' !important;\n  box-shadow: none;\n  word-wrap: normal;\n';

  var buttonLargeStyles = exports.buttonLargeStyles = '\n  font-size: 1rem !important;\n  padding: 1rem 2rem !important;\n  border-radius: 4px !important;\n  line-height: 1.5 !important;\n\n  &:hover {\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);\n  }\n';

  var buttonSmallStyles = exports.buttonSmallStyles = '\n  font-size: 0.8125rem;\n  padding: 0.5rem 1rem;\n  border-radius: 3px;\n  line-height: 1.23;\n\n  &:hover {\n    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24);\n  }\n';

  var buttonPrimaryStyles = exports.buttonPrimaryStyles = '\n  background-color: ' + jungle + ' !important;\n  color: ' + white + ' !important;\n  font-family: ' + _fonts.ProximaNovaA + ';\n\n  &:not([disabled]):not(.disabled):active {\n    background-color: ' + jungle + ' !important;\n    box-shadow: none;\n  }\n\n  &:disabled, &[disabled], &.disabled {\n    opacity: 1;\n    background-color: #dedede !important;\n    color: ' + slate + ' !important;\n    font-weight: normal;\n  }\n  ';

  // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
  // font-family: ${ProximaNova};

  var buttonSecondaryStyles = exports.buttonSecondaryStyles = '\n  background-color: transparent !important;\n  color: ' + jungle + ' !important;\n  border: 1px solid ' + jungle + ' !important;\n  font-family: ' + _fonts.ProximaNova + ';\n\n  &:not([disabled]):not(.disabled):active {\n    background-color: #f2f2f2 !important;\n    box-shadow: none;\n  }\n\n  &:disabled, &[disabled], &.disabled {\n    border: 0 !important;\n    color: #a3a3a3 !important;\n    opacity: 1;\n    background-color: #dedede !important;\n    font-family: ' + _fonts.ProximaNova + ';\n  }\n';

  var buttonFlatStyles = exports.buttonFlatStyles = '\n  background-color: transparent !important;\n  color: ' + jungle + ' !important;\n  border 0 !important;\n\n  &:hover {\n    background-color: ' + platinum + ' !important;\n    box-shadow: none;\n  }\n\n  &:not([disabled]):not(.disabled):active {\n    background-color: ' + silver + ' !important;\n    box-shadow: none;\n  }\n\n  &:disabled, &[disabled], &.disabled {\n    color: ' + stone + ' !important;\n    background-color: transparent !important;\n    opacity: 1;\n  }\n';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/Buttons.css.js
// module id = 1183
// module chunks = 0